// src/pages/About.js
import React from 'react';
import { useTranslation } from 'react-i18next';

const About = () => {
    const { t } = useTranslation();

return (
  <section className="bg-[#0f172a] text-white" style={{ marginTop: '-15px', width: '100%' }}>
    <div className="grid grid-cols-1 md:grid-cols-2 min-h-[520px]">

      {/* Left side */}
      <div className="bg-[#070b2b] px-6 sm:px-10 py-12 sm:py-16 flex flex-col justify-center">
        <h1 className="text-5xl sm:text-6xl lg:text-[72px] leading-none font-extrabold text-[#ff6a00] mb-8 sm:mb-10 break-words">
          {t('about.brand')}
        </h1>

        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight max-w-xl mb-8 sm:mb-10 break-words">
          {t('about.heroTitle')}
        </h2>

        <div className="flex items-start gap-4 border-l-4 border-[#ff6a00] pl-4">
          <p className="text-base sm:text-lg lg:text-xl text-gray-300 leading-relaxed break-words">
            {t('about.heroSubtitle')}
          </p>
        </div>
      </div>

      {/* Right side */}
      <div className="bg-[#1d243b] px-6 sm:px-12 py-12 sm:py-16 flex flex-col justify-center">
        <span className="text-[#ff6a00] font-bold tracking-[0.2em] text-xs sm:text-sm uppercase mb-6">
          {t('about.problem.label')}
        </span>

        <h3 className="text-2xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-8 sm:mb-10 max-w-2xl break-words">
          {t('about.problem.heading')}
        </h3>

        <ul className="space-y-5 sm:space-y-6 mb-10 sm:mb-14">
          {[
            "about.problem.items.watch",
            "about.problem.items.review",
            "about.problem.items.experience",
            "about.problem.items.lms",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3 sm:gap-4">
              <span className="mt-2 h-2.5 w-2.5 sm:h-3 sm:w-3 bg-[#ff6a00] shrink-0" />
              <span className="text-base sm:text-lg lg:text-xl text-gray-300 leading-relaxed break-words">
                {t(item)}
              </span>
            </li>
          ))}
        </ul>

        <div className="border border-[#ff6a00] p-5 sm:p-8 max-w-2xl">
          <div className="flex items-center gap-3 mb-4">
            <span className="text-xl sm:text-2xl">👉</span>

            <span className="text-[#ff6a00] text-lg sm:text-xl lg:text-2xl font-bold uppercase break-words">
              {t('about.result.label')}
            </span>
          </div>

          <p className="text-lg sm:text-xl lg:text-2xl leading-relaxed text-gray-100 break-words">
            {t('about.result.description')}
          </p>
        </div>

      </div>
    </div>
  </section>
);
};

export default About;